import React, {Suspense, useMemo, useRef, useEffect, useState, useCallback} from 'react';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader'
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader'
import { useLoader, useFrame} from "@react-three/fiber";
import { useProgress } from '@react-three/drei';
import SystemConfiguration from 'settings/SystemConfiguration';
import * as THREE from "three";
import { LoadingManager } from 'three';
import { Html } from '@react-three/drei'
import { unzipSync, strFromU8 } from 'fflate';

import $ from "jquery"


const TriangleMesh = (props) => {
    const [objd, setObj] = useState(null)
    const [loaded, setLoaded] = useState(0)
    const [center, setCenter] = useState([0,0,0])
    const [scaling, setScaling] = useState(1.0)
    const [complete, setComplete] = useState(false)

    useEffect(() => {
        const loader = new OBJLoader();
        // load a resource
        loader.load(
            // resource URL
            process.env.PUBLIC_URL + '/' + props.file_name +'.obj',
            // called when resource is loaded
            function ( object ) {
                const mtlLoader = new MTLLoader();
                mtlLoader.load(
                    process.env.PUBLIC_URL + '/' + props.file_name +'.mtl',
                    function (mtl) {
                        setObj(object)

                        mtl.preload();

                        SystemConfiguration.mesh = object.children[0]

                        if(!Array.isArray(object.children[0].material)) {
                            if(object.children[0].material.map == null) {
                                object.children[0].material = mtl.materials[object.children[0].material.name];
                                object.children[0].material.map_temp = mtl.materials[object.children[0].material.name].map
                                object.children[0].material.map_null = new THREE.TextureLoader().load(window.location.href + "/assets/template_texture.png")
                            }

                            SystemConfiguration.material = object.children[0].material

                            //SystemConfiguration.material.map.colorSpace = THREE.SRGBColorSpace;
                            //SystemConfiguration.material.map.colorSpace = THREE.LinearSRGBColorSpace;

                            //SystemConfiguration.material.map.encoding = 3000           
                            //SystemConfiguration.material.map.format = THREE.RGBAFormat
                            //SystemConfiguration.material.map.type = THREE.UnsignedIntType
                            SystemConfiguration.material.specular = {r:1,g:0,b:0}

                            // check if the wireframe view was enabled before
                            if (SystemConfiguration.wireframeEnabled) {
                                SystemConfiguration.material.wireframe = true
                            }
                            else {
                                SystemConfiguration.material.wireframe = false
                            }

                            //check if the texture view was disabled before
                            if (!SystemConfiguration.textureEnabled) {
                                SystemConfiguration.material.color = {r: 0.1, g: 0.1, b: 0.1}
                                SystemConfiguration.material.map = SystemConfiguration.material.map_null//SystemConfiguration.template_texture
                                SystemConfiguration.material.needsUpdate = true
                            }
                            else {
                                SystemConfiguration.material.map = SystemConfiguration.material.map_temp
                                SystemConfiguration.material.color = {r: 1.0, g: 1.0, b: 1.0}
                                //SystemConfiguration.material.toneMapped = false
                                SystemConfiguration.material.needsUpdate = true
                            }

                            //check if the x-ray view was disabled before
                            if (!SystemConfiguration.xrayEnabled) {
                                SystemConfiguration.material.transparent = false
                                SystemConfiguration.material.opacity = 1.0
                                SystemConfiguration.material.side = THREE.DoubleSide
                                SystemConfiguration.material.needsUpdate = true
                            }
                            else {
                                SystemConfiguration.material.transparent = true
                                SystemConfiguration.material.opacity = 0.5
                                SystemConfiguration.material.side = THREE.DoubleSide
                                SystemConfiguration.material.needsUpdate = true
                            }

                        }
                        else {
                            SystemConfiguration.material = []
                            for(var i = 0; i < object.children[0].material.length; i++){
                                // if map is null, the mesh was loaded the first time
                                if(object.children[0].material[i].map == null) {
                                    object.children[0].material[i] = mtl.materials[object.children[0].material[i].name];
                                    object.children[0].material[i].map_temp = mtl.materials[object.children[0].material[i].name].map
                                    object.children[0].material[i].map_null = new THREE.TextureLoader().load(window.location.href + "/assets/template_texture.png")
                                }

                                var matName = object.children[0].material[i].name
                                object.children[0].material[i] = mtl.materials[matName]
                                object.children[0].material[i].specular = {r:0,g:0,b:0}

                                SystemConfiguration.material.push(object.children[0].material[i])

                                // check if the wireframe view was enabled before
                                if (SystemConfiguration.wireframeEnabled) {
                                    SystemConfiguration.material[i].wireframe = true
                                }
                                else {
                                    SystemConfiguration.material[i].wireframe = false
                                }

                                // check if the texture view was disabled before
                                if (!SystemConfiguration.textureEnabled) {
                                    object.children[0].material[i].color = {r: 0.1, g: 0.1, b: 0.1}
                                    object.children[0].material[i].map = null
                                    object.children[0].material[i].needsUpdate = true
                                }
                                else {
                                    SystemConfiguration.material[i].map = SystemConfiguration.material[i].map_temp
                                    SystemConfiguration.material[i].color = {r: 1.0, g: 1.0, b: 1.0}
                                    SystemConfiguration.material[i].needsUpdate = true
                                }

                                //check if the x-ray view was disabled before
                                if (!SystemConfiguration.xrayEnabled) {
                                    SystemConfiguration.material[i].transparent = false
                                    SystemConfiguration.material[i].opacity = 1.0
                                    SystemConfiguration.material[i].side = THREE.DoubleSide
                                    SystemConfiguration.material[i].needsUpdate = true
                                }
                                else {
                                    SystemConfiguration.material[i].transparent = true
                                    SystemConfiguration.material[i].opacity = 0.5
                                    SystemConfiguration.material[i].side = THREE.DoubleSide
                                    SystemConfiguration.material[i].needsUpdate = true
                                }
                            }
                            SystemConfiguration.material = object.children[0].material
                        }

                        object.children[0].geometry.computeBoundingSphere();
                        var center = object.children[0].geometry.boundingSphere.center
                        var radius = object.children[0].geometry.boundingSphere.radius
                        var scaling = 1.0 / radius
                        setCenter(center)
                        setScaling(scaling)

                        setComplete(true)



                        console.log(SystemConfiguration.mesh)

                        console.log(SystemConfiguration.material)
                    }
                )   
            },
            // called when loading is in progresses
            function ( xhr ) {
                var progress = ( xhr.loaded / xhr.total * 100 );
                //setLoaded(progress)calc(100% - 2px)
                $("#rightpanel_statusbar").css("width", progress.toString() + "%")
                $("#rightpanel_statusbar").css("width", "calc(" + progress.toString() + "% - 2px)")
                //console.log( ( xhr.loaded / xhr.total * 100 ) + '% loaded' );

            },
            // called when loading has errors
            function ( error ) {
                console.log(error)
                console.log( 'An error happened' );

            }
        );
    }, [props.file_name])

    if(!complete) {
        return (
            <group position={[0,0,0]} scale={1}>
                
            </group>
        )
    } else {
        return (
            <group position={[-center.x*scaling, -center.y*scaling + 1.0, -center.z*scaling]} scale={scaling}>
                <mesh geometry={SystemConfiguration.mesh.geometry} material={SystemConfiguration.mesh.material} dispose={null}/>  
            </group>
        )
    }



    // var objd = useLoader(OBJLoader, process.env.PUBLIC_URL + '/' + props.file_name +'.obj')
        
    // var mtl = useLoader(MTLLoader, process.env.PUBLIC_URL + '/' + props.file_name +'.mtl')
    // mtl.preload();

    // SystemConfiguration.mesh = objd.children[0]

    // if(!Array.isArray(objd.children[0].material)) {
    //     if(objd.children[0].material.map == null) {
    //         objd.children[0].material = mtl.materials[objd.children[0].material.name];
    //         objd.children[0].material.map_temp = mtl.materials[objd.children[0].material.name].map
    //         objd.children[0].material.map_null = new THREE.TextureLoader().load(window.location.href + "/assets/template_texture.png")
    //     }

    //     SystemConfiguration.material = objd.children[0].material
    //     SystemConfiguration.material.specular = {r:0,g:0,b:0}

    //     // check if the wireframe view was enabled before
    //     if (SystemConfiguration.wireframeEnabled) {
    //         SystemConfiguration.material.wireframe = true
    //     }
    //     else {
    //         SystemConfiguration.material.wireframe = false
    //     }

    //     //check if the texture view was disabled before
    //     if (!SystemConfiguration.textureEnabled) {
    //         SystemConfiguration.material.color = {r: 0.1, g: 0.1, b: 0.1}
    //         SystemConfiguration.material.map = SystemConfiguration.material.map_null//SystemConfiguration.template_texture
    //         SystemConfiguration.material.needsUpdate = true
    //     }
    //     else {
    //         SystemConfiguration.material.map = SystemConfiguration.material.map_temp
    //         SystemConfiguration.material.color = {r: 1.0, g: 1.0, b: 1.0}
    //         SystemConfiguration.material.needsUpdate = true
    //     }

    //     //check if the x-ray view was disabled before
    //     if (!SystemConfiguration.xrayEnabled) {
    //         SystemConfiguration.material.transparent = false
    //         SystemConfiguration.material.opacity = 1.0
    //         SystemConfiguration.material.side = THREE.DoubleSide
    //         SystemConfiguration.material.needsUpdate = true
    //     }
    //     else {
    //         SystemConfiguration.material.transparent = true
    //         SystemConfiguration.material.opacity = 0.5
    //         SystemConfiguration.material.side = THREE.DoubleSide
    //         SystemConfiguration.material.needsUpdate = true
    //     }

    // }
    // else {
    //     SystemConfiguration.material = []
    //     for(var i = 0; i < objd.children[0].material.length; i++){
    //         // if map is null, the mesh was loaded the first time
    //         if(objd.children[0].material[i].map == null) {
    //             objd.children[0].material[i] = mtl.materials[objd.children[0].material[i].name];
    //             objd.children[0].material[i].map_temp = mtl.materials[objd.children[0].material[i].name].map
    //             objd.children[0].material[i].map_null = new THREE.TextureLoader().load(window.location.href + "/assets/template_texture.png")
    //         }

    //         var matName = objd.children[0].material[i].name
    //         objd.children[0].material[i] = mtl.materials[matName]
    //         objd.children[0].material[i].specular = {r:0,g:0,b:0}

    //         SystemConfiguration.material.push(objd.children[0].material[i])

    //         // check if the wireframe view was enabled before
    //         if (SystemConfiguration.wireframeEnabled) {
    //             SystemConfiguration.material[i].wireframe = true
    //         }
    //         else {
    //             SystemConfiguration.material[i].wireframe = false
    //         }

    //         // check if the texture view was disabled before
    //         if (!SystemConfiguration.textureEnabled) {
    //             objd.children[0].material[i].color = {r: 0.1, g: 0.1, b: 0.1}
    //             objd.children[0].material[i].map = null
    //             objd.children[0].material[i].needsUpdate = true
    //         }
    //         else {
    //             SystemConfiguration.material[i].map = SystemConfiguration.material[i].map_temp
    //             SystemConfiguration.material[i].color = {r: 1.0, g: 1.0, b: 1.0}
    //             SystemConfiguration.material[i].needsUpdate = true
    //         }

    //         //check if the x-ray view was disabled before
    //         if (!SystemConfiguration.xrayEnabled) {
    //             SystemConfiguration.material[i].transparent = false
    //             SystemConfiguration.material[i].opacity = 1.0
    //             SystemConfiguration.material[i].side = THREE.DoubleSide
    //             SystemConfiguration.material[i].needsUpdate = true
    //         }
    //         else {
    //             SystemConfiguration.material[i].transparent = true
    //             SystemConfiguration.material[i].opacity = 0.5
    //             SystemConfiguration.material[i].side = THREE.DoubleSide
    //             SystemConfiguration.material[i].needsUpdate = true
    //         }
    //     }
    //     SystemConfiguration.material = objd.children[0].material
    // }

    // objd.children[0].geometry.computeBoundingSphere();
    // console.log(objd.children[0].geometry.boundingSphere)
    // var center = objd.children[0].geometry.boundingSphere.center
    // var radius = objd.children[0].geometry.boundingSphere.radius
    // var scaling = 1.0 / radius

    // var center = [0,0,0]
    // var scaling = 1.0

    return (
            <group position={[-center.x*scaling, -center.y*scaling + 1.0, -center.z*scaling]} scale={scaling}>
                    <mesh geometry={objd.children[0].geometry} material={objd.children[0].material} dispose={null}/>  
            </group>
    );

};

export default TriangleMesh;